import React, {Fragment, useState} from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";

import Button from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";

import {
  setWizardActiveItem,
  setWizardActiveStep,
  setWizardSelectedValues
} from "../../../../../actions/wizardFunctions";
import WithAddToCartPostMessage from "../../../hocs/withAddToCartPostMessage";
import WithUpdateCartItems from "../../../hocs/withUpdateCartItems";
import {
  filterCartItems,
  getCartItemsArrayFromFeature,
  getLookIdUrl,
  isInStock
} from "../../../lookNavigation/lookFunctions2";
import {ROUTES} from "../../../../../routes";
import {setLookActiveFeature, setLookOpened, setLookPageOpened} from "../../../../../actions/lookFunctions";
import {zoomCanvasOut} from "../../../lookNavigation/lookFunctions";
import LookCanvasContext from "../../../lookCanvasContext";
import {setCanvasScale} from "../../../../../actions/actionFunctions";
import {isIframe} from "../../../../../misc/helpers";

const GroheWizardCompletedButtons = (props) => {

  const {setWizardActiveStep, wizardSelectedValues, setWizardSelectedValues, qtActiveCategory, wizardSqftCartItems,
    setWizardActiveItem, setLookPageOpened, history, setCanvasScale, shopPageOpened, setLookOpened, isMobile,
    fabricatorData, setLookActiveFeature, cartItems} = props;
  const fabricatorSettings = fabricatorData.settings;

  const [addedToCartClicked, setAddedToCartClicked] = useState(false);

  const continueShopping = (imageCanvas) => {
    // Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookWizardCompletedClose);
    setLookActiveFeature(null);
    setWizardSelectedValues({}, true);
    setWizardActiveStep(0);
    setWizardActiveItem(null);
    if (shopPageOpened) {
      setLookOpened(false);
      if (fabricatorSettings.checkout) {
        setLookPageOpened(ROUTES.cart);
        history.push(ROUTES.cart);
      }
      return
    }
    setLookPageOpened(fabricatorSettings.checkout ? ROUTES.cart : ROUTES.category);
    zoomCanvasOut(imageCanvas, setCanvasScale);
    history.push(fabricatorSettings.checkout ? ROUTES.cart : getLookIdUrl());
  }

  const selectedValues = Object.keys(wizardSelectedValues)
    .filter(key => wizardSelectedValues[key].selectedFeature && isInStock(wizardSelectedValues[key].selectedFeature))
    .map(key => wizardSelectedValues[key])

  const canBeAdded = selectedValues
      .filter(wizardSelectedValue => !Number.isInteger(wizardSelectedValue.quantity) || wizardSelectedValue.quantity > 0)
      .map(wizardSelectedValue => wizardSelectedValue.selectedFeature)

  const addAllToCartButtonClick = (updateCartItems, addToCartPostMessage) => {
    updateCartItems(canBeAdded, selectedValues, wizardSqftCartItems);
    if (isIframe() && fabricatorData.isLixil) { // not sure if we need it
      let cartItemsArray = [];
      canBeAdded.forEach(requiredFeature => {
        const parent = requiredFeature.getParent();
        const quantity = parent.layerPositions
          ? Object.keys(parent.layerPositions).filter(position => parent.layerPositions[position]).length
          : 1;
        return cartItemsArray = [...cartItemsArray, ...getCartItemsArrayFromFeature(requiredFeature, quantity, qtActiveCategory)]
      })
      addToCartPostMessage(cartItemsArray);  // not sure if we need it
    }
    // if (isMobile) {
    //   setLookActiveFeature(null);
    //   setWizardSelectedValues({}, true);
    //   setWizardActiveStep(0);
    //   setWizardActiveItem(null);
    //   zoomCanvasOut(imageCanvas, setCanvasScale);
    //   setLookOpened(false);
    //   setLookPageOpened("");
    //   history.push(ROUTES.home);
    // } else {
    //   setAddedToCartClicked(true);
    // }
    setAddedToCartClicked(true);
  };

  const getCartButtonText = () => {
    if (addedToCartClicked) {
      return <FormattedMessage id={canBeAdded.length > 1 ? "grohe.feature.addedToCartAll" : "grohe.feature.addedToCart"}/>
    }
    if (canBeAdded.length > 1) {
      return (
        <Fragment>
          <FormattedMessage id={"grohe.feature.addAllToCartButton"}/> ({canBeAdded.length})
        </Fragment>
      )
    }
    return <FormattedMessage id={"grohe.feature.addToCartButton"}/>
  }

  const cartItemsToInclude = filterCartItems(cartItems);
  const checkoutDisabled = fabricatorSettings.checkout && !cartItemsToInclude.length;
  const addToCartDisabled = !addedToCartClicked && !canBeAdded.length;

  return (
    <LookCanvasContext.Consumer>
      {(imageCanvas) => (
        <Fragment>
          {isMobile ? (
            <Button className={"look-button look-button--secondary look-button--no-radius look-button--no-padding"
              + (checkoutDisabled ? " look-button--disabled" : "")}
                    disabled={checkoutDisabled}
                    onClick={() => checkoutDisabled ? null : continueShopping(imageCanvas)}>
              <FormattedMessage id={fabricatorSettings.checkout ? "buttons.checkout" : "grohe.feature.continiueShopping"}/>
            </Button>
          ) : null}
          {fabricatorSettings.checkout ? (
            <WithUpdateCartItems>
              {(updateCartItems) => (
                <WithAddToCartPostMessage>
                  {(addToCartPostMessage) => isMobile ? (
                    <Button className={"look-button look-button--secondary look-button--no-radius look-button--no-padding look-button--grohe-active"
                      + (addToCartDisabled ? " look-button--disabled" : "")}
                            disabled={addToCartDisabled}
                            onClick={() => addToCartDisabled ? null : addAllToCartButtonClick(updateCartItems, addToCartPostMessage, imageCanvas)}>
                      {getCartButtonText()}
                    </Button>
                  ) : (
                    <div className="lk-button grohe-lk__button grohe-lk__button--small">
                      {addedToCartClicked ? (
                        <h2 className="lk-title__text lk-title__text--as-button grohe-icontext">
                          <CheckIcon fontSize="small"/>
                          <span className="grohe-icontext__cell">
                          {getCartButtonText()}
                        </span>
                        </h2>
                      ) : (
                        <Button className={"look-button look-button--primary look-button--no-transform"}
                                disabled={addToCartDisabled}
                                onClick={() => addToCartDisabled ? null : addAllToCartButtonClick(updateCartItems, addToCartPostMessage, imageCanvas)}>
                          {getCartButtonText()}
                        </Button>
                      )}
                    </div>
                  )}
                </WithAddToCartPostMessage>
              )}
            </WithUpdateCartItems>
          ) : null}
          {isMobile ? null : (
            <div className="lk-button grohe-lk__button grohe-lk__button--small">
              <Button className={"look-button look-button--secondary look-button--no-transform" + (checkoutDisabled ? " look-button--disabled" : "")}
                      disabled={checkoutDisabled}
                      onClick={() => checkoutDisabled ? null : continueShopping(imageCanvas)}>
                <FormattedMessage id={fabricatorSettings.checkout ? "buttons.checkout" : "grohe.feature.continiueShopping"}/>
              </Button>
            </div>
          )}
        </Fragment>
      )}
    </LookCanvasContext.Consumer>
  )

};

const mapStateToProps = (store) => {
  const {wizardActiveItem, wizardActiveStep, wizardSelectedValues, wizardSqftCartItems} = store.wizardState;
  const {isMobile} = store.serverState;
  const {cartItems} = store.cartState;
  const {qtActiveCategory} = store.qtState;
  const {shopPageOpened} = store.shopState;
  const fabricatorData = store.fabricatorState;

  return {
    wizardActiveItem,
    wizardActiveStep,
    wizardSelectedValues,
    isMobile,
    cartItems,
    qtActiveCategory,
    shopPageOpened,
    fabricatorData,
    wizardSqftCartItems,
  };
};

const mapDispatchToProps = {
  setWizardActiveStep,
  setWizardSelectedValues,
  setWizardActiveItem,
  setLookPageOpened,
  setCanvasScale,
  setLookOpened,
  setLookActiveFeature,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(GroheWizardCompletedButtons)
  )
)
